import React, { useState, useEffect } from "react";
import { useUser } from "../components/accounts/UserProvider";
import "../CSS/Dashboard.css";
import {
  Button,
  CreateTeamForm,
  Navbar,
  ProductivityGraph,
} from "../components/indexComponents";
import { Link } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function Dashboard() {
  const { user } = useUser();

  const username = user ? user.username : "Inconnu";
  const userEmail = user ? user.email : "Inconnu";

  const [formTeam, setFormTeam] = useState(false);
  const [teams, setTeams] = useState([]);
  const [stepDone, setStepDone] = useState([]);

  /* #region  Teams */
  // Récupérer tous les équipes dont l'utilisateur est membre
  const fetchTeams = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/teams`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch teams");
      }

      const data = await response.json();
      setTeams(data);
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };
  /* #endregion */

  const getStepDone = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/step-done`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch teams");
      }

      const data = await response.json();
      setStepDone(data);
      extractStepsDoneValues(data);
    } catch (error) {
      console.error("Error updating step done:", error);
    }
  };

  useEffect(() => {
    fetchTeams();
    getStepDone();
  }, []);

  const getPastWeekDates = () => {
    let dates = "0123456".split("").map((day) => {
      let tempDate = new Date();
      tempDate.setDate(tempDate.getDate() - day);
      return tempDate.toLocaleDateString("en-US"); // Modifiez le format ici
    });
    return dates.reverse();
  };

  const extractStepsDoneValues = (stepsDone) => {
    console.log("stepsDone : ", stepsDone);

    // Créez un tableau pour les 7 derniers jours
    const last7Days = getPastWeekDates().map((date) => ({
      date: new Date(date).toLocaleDateString("en-US"), // Assurez-vous que le format est correct
      nbre_steps_done: 0,
    }));

    // Remplir le tableau avec les valeurs des étapes effectuées
    for (const step of stepsDone) {
      const stepDate = new Date(step.date).toLocaleDateString("en-US");
      const index = last7Days.findIndex((day) => day.date === stepDate);
      console.log("index :", index);
      if (index !== -1) {
        last7Days[index + 1].nbre_steps_done = step.nbre_steps_done;
      }
    }

    console.log("last7Days : ", last7Days);
    // Retournez seulement les valeurs des étapes effectuées
    return last7Days.map((day) => day.nbre_steps_done);
  };

  return (
    <div className="dashboard-frame page-frame">
      <Navbar />
      <div className="dashboard-content page-content">
        {/* {user ? ( */}
        <>
          <div className="dashboard-header">
            <h1>
              Bienvenue sur votre tableau de bord, <span>{username}</span> !
            </h1>
            <h2>Votre email : {userEmail}</h2>
          </div>

          <div className="btn-container">
            {formTeam ? (
              ""
            ) : (
              <button
                onClick={() => {
                  setFormTeam(true);
                }}
              >
                Créer une équipe
              </button>
            )}

            <Link to="/active-tasks">
              <button>Voir les tâches actives</button>
            </Link>
          </div>

          {formTeam ? (
            <CreateTeamForm
              onTeamAdded={fetchTeams}
              close={() => {
                setFormTeam(false);
              }}
            />
          ) : (
            ""
          )}
          <div className="graph-container">
            <h2>Productivité (7 derniers jours)</h2>
            {stepDone ? (
              <ProductivityGraph
                numberOfStep={extractStepsDoneValues(stepDone)}
              />
            ) : (
              ""
            )}
          </div>

          <div className="list-container">
            <div className="team-list">
              <h3>Équipes</h3>
              <ul>
                {teams.map((team) => (
                  <li key={team.id}>
                    {team.name}
                    <Button text="Voir" route={`/team/${team.id}`} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </>
        {/* ) : (
        <h1>Chargement...</h1>
        )} */}
      </div>
    </div>
  );
}

export default Dashboard;
